import { Mail, Cpu, DatabaseIcon, Diamond, CurlyBraces, PlugIcon } from 'lucide-react';

export const getStepIcon = (stepType: string, clsx: string = 'w-6 h-6 text-white') => {
    switch (stepType) {
        case "data-source":
            return <DatabaseIcon className={clsx} />;
        case "llm":
            return <Cpu className={clsx} />;
        case "email":
            return <Mail className={clsx} />;
        case "decision":
            return <Diamond className={clsx} />;
        case "data-extraction":
            return <CurlyBraces className={clsx} />;
        case "api-destination":
            return <PlugIcon className={clsx} />;
        default:
            return <DatabaseIcon className={clsx} />;
    }
};

export const setCookie = (name: string, value: string, days: number) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

export const getCookie = (name: string) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export const eraseCookie = (name: string) => {
    document.cookie = name + '=; Max-Age=-99999999;';
}

// Helper function to format fiscal date ending
export const formatFiscalDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric',
        timeZone: 'UTC'
    });
};

// Helper function to get status badge info
export const getStatusBadge = (eventType: string, isTranscript: boolean) => {
    if (isTranscript) {
        return { text: 'Transcript', className: 'bg-green-100 text-green-800 border-green-200' };
    }
    switch (eventType) {
        case 'transcript':
            return { text: 'Earnings Call', className: 'bg-blue-100 text-blue-800 border-blue-200' };
        case 'earnings':
            return { text: 'Earnings Report', className: 'bg-purple-100 text-purple-800 border-purple-200' };
        default:
            return { text: 'Filing', className: 'bg-gray-100 text-gray-800 border-gray-200' };
    }
};

// Helper function to get event type color
export const getEventTypeColor = (eventType: string): string => {
    switch (eventType) {
        case 'earnings_call':
            return 'text-blue-600';
        case '10-k':
            return 'text-purple-600';
        case '10-q':
            return 'text-indigo-600';
        case '8-k':
            return 'text-orange-600';
        default:
            return 'text-gray-600';
    }
};